// OBSOLETO - Pendiente de revisar
// @deprecated Usar GlossaryDtoV2 de @/shared/dtos/Governance/glossary-dto-v2
// Para glosarios con términos usar GlossaryWithTermsDtoV2
import i18n from "@/i18n/i18n";
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";
import { AccessRightDto } from "./Governance/access-right-dto";
import { AgentDto } from "./Governance/agent-dto";
import { CategoryDtoV2 } from "./category-dto";
import { Languagev2Dto } from "./language-list-dto";
import { TermDto } from "./term-dto";

export class GlossaryV2Dto extends ItiBaseDto {
	title: string;
	shortDescription: string;
	longDescription?: string;
	accessRights?: AccessRightDto;
	accessRightsId?: number;
	categories: CategoryDtoV2[];
	terms?: TermDto[];
	owner?: AgentDto;
	ownerName?: string;
	languageId?: string;
	language?: Languagev2Dto;
	creator?: AgentDto;
	publisher?: AgentDto;
	modifier?: AgentDto;
	created?: string;
	modified?: string;
	glossaryId?: string;
	example?: string;
	usage?: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);

		if (!this.accessRightsId && src?.accessRights?.id) {
			this.accessRightsId = src.accessRights.id;
		}

		if (src?.categories && Array.isArray(src.categories)) {
			src.categories = src.categories.map(
				(x: any) => new CategoryDtoV2(x).title,
			);
		}
	}

	public get allTerms() {
		return this.terms?.map((term) => {
			return ` ${term.title}`;
		});
	}

	public get translatedVisibility(): string {
		return this.accessRights?.code
			? i18n.t(`dataset-visibility.${this.accessRights.code.toLowerCase()}`)
			: "";
	}
}
